module.exports = __webpack_public_path__ + "static/img/21nuli.c6312b42.gif";